import * as React from 'react';
import classnames from 'classnames';

import SVGIcon from 'components/svg-icon/SVGIcon';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import LazyLoadImg from 'components/lazy-load-img/LazyLoadImg';

import { StorySnippet } from '../../../../types';

import './select-story-snippets-list.scss';

interface Props {
  snippets: Array<StorySnippet>,
  selectedSnippets: Array<string>,
  previewSnippetCode: null | string,
  onChange: (code: string) => void,
  onRequestPreview: (code: string) => void
}

const SelectStorySnippetsList = ({
  snippets,
  selectedSnippets,
  previewSnippetCode,
  onChange,
  onRequestPreview
}: Props): JSX.Element => (
  <div className="select-story-snippets-list">
    {snippets.map(s => (
      <div
        key={s.code}
        className={classnames('select-story-snippets-list__item', {
          'select-story-snippets-list__item--selected': selectedSnippets.includes(s.code)
            || previewSnippetCode === s.code
        })}
      >
        <div
          className="select-story-snippets-list__thumbnail"
          onClick={() => onRequestPreview(s.code)}
        >
          <LazyLoadImg
            className="select-story-snippets-list__image"
            src={s.imageUrl}
            alt={s.takenAt}
          />
          {s.videoUrl ? (
            <div className="select-story-snippets-list__play-button">
              <SVGIcon
                name="play-button"
                width={24}
                height={24}
              />
            </div>
          ) : null}
        </div>
        <div
          className={classnames('select-story-snippets-list__item-checkbox', {
            'select-story-snippets-list__item-checkbox--selected': selectedSnippets.includes(s.code)
            || previewSnippetCode === s.code
          })}
        >
          <InputCheckbox
            id={`story-snippet-${s.code}`}
            checked={selectedSnippets.includes(s.code)}
            onChange={() => onChange(s.code)}
          />
        </div>
      </div>
    ))}
  </div>
);

export default SelectStorySnippetsList;
